import { setupWorker } from "msw/browser";
import productHandler from "@features/product/mocks/handlers";
import searchHandler from "@features/search/mocks/handlers";
import managementHandler from "@features/management/mocks/handlers";

export const worker = setupWorker(...productHandler, ...searchHandler, ...managementHandler);
